<template>
    <div class="d-flex flex-wrap align-items-end">
        <div class="col-12 sm-max-w-1200px" style="">
            <div v-if="!displayOptionUpsideDown" class="row">
                <div class="d-flex flex-wrap align-items-end" style="flex: 1 1 auto;">
                    <!-- 所属部署 -->
                    <div v-if="displayDepartment" class="col-12 sm-max-w-200px mb-20px">
                        <label :for="'search_department_id_'+index" class="mb-0" style="font-size:0.8rem;">所属部署</label>
                        <div :id="'search_department_id_'+index" class="">
                            <custom-tree-select
                                :items=departments
                                ref="searchDepartmentId"
                                :input-name="'search_department_id_' + index"
                                :value=activeDepartments
                                :multiple=multipleDepartment
                                :open-all="true"
                                selection-type="independent"
                                selection-mode="all"
                                :select-all="false"
                                :input-default-string="inputDefaultString"
                                @on-selection-change="onSelectionChangeDepartment($event)"
                            />
                        </div>
                    </div>
                    <!-- 役職 -->
                    <div v-if="displayPost" class="col-12 sm-max-w-150px mb-20px">
                        <label :for="'search_post_id_'+index" class="mb-0" style="font-size:0.8rem;">役職</label>
                        <div class="">
                            <select :id="'search_post_id_'+index" class="custom-mdb-select md-form m-0" :name="'search_post_id_' + index" v-on:change.stop="onSelectionChange($event)">
                                <option value="">未選択</option>
                                <option v-for="post in posts" :key="post.id" :value=post.id :selected="activePosts.indexOf(post.id) >= 0">{{post.name}}</option>
                            </select>
                        </div>
                    </div>
                    <!-- 雇用体系 -->
                    <div v-if="displayEmployment" class="col-12 sm-max-w-150px mb-20px">
                        <label :for="'search_employment_id_'+index" class="mb-0" style="font-size:0.8rem;">雇用体系</label>
                        <div class="">
                            <select :id="'search_employment_id_'+index" class="custom-mdb-select md-form m-0" :name="'search_employment_id_' + index" v-on:change.stop="onSelectionChange($event)">
                                <option value="">未選択</option>
                                <option v-for="employment in employments" :key="employment.id" :value=employment.id :selected="activeEmployments.indexOf(employment.id) >= 0">{{employment.name}}</option>
                            </select>
                        </div>
                    </div>
                    <!-- 社員 -->
                    <div v-if="displayUser" class="col-12 sm-max-w-250px mb-20px">
                        <label :for="'search_user_id_'+index" class="mb-0" style="font-size:0.8rem;">社員</label>
                        <div class="">
                            <select :id="'search_user_id_'+index" class="custom-mdb-select md-form m-0" :name="'search_user_id_' + index" v-on:change.stop="onSelectionChange($event)" multiple>
                                <option value="" disabled selected>未選択</option>
                                <option v-for="user in users" :key="user.id" :value=user.id :selected="activeUsers.indexOf(user.id) >= 0">{{user.identification_code}} : {{user.name}}</option>
                            </select>
                        </div>
                    </div>
                    <!-- チェックボックス(オプション) -->
                    <div v-if="displayOptionCheckBox" class="col-12 sm-max-w-250px mb-20px">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" :id="'search_option_check_'+index" :name="'search_option_check_' + index" v-model="optionCheckBoxState">
                            <label class="form-check-label ml-0" :for="'search_option_check_'+index">{{ optionCheckBoxString }}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <!--            <div class="col-12 p-0 d-flex justify-content-between flex-wrap">-->
                <!--                <div class="d-flex flex-wrap" style="flex: 1 1 auto;">-->
                <!-- 検索範囲 -->
                <div v-if="displayDate" :class='[dateWorkMode === "YMD" ? "col-12 sm-max-w-370px" : "col-12 sm-max-w-330px"]'>
                    <label class="mb-0">検索範囲</label>
                    <div class="w-100 d-flex align-items-center flex-wrap">
                        <div :id="'search_start_date_'+index" :class='[dateWorkMode === "YMD" ? "w-100 max-w-140px mb-10px" : "w-100 max-w-120px mb-10px"]'>
                            <md-datepicker :work-mode="dateWorkMode" :attr-name="'search_start_date_' + index" :ref="'search_start_date_' + index" :value="dateValue"/>
                        </div>
                        <div class="max-w-70px px-10px mb-10px">
                            <select :id="'search_compare_mode_'+index" class="custom-mdb-select md-form m-0" :name="'search_compare_mode_' + index" :disabled="index!==0">
                                <option value="0" selected>～</option>
                                <option value="1" >AND</option>
                            </select>
                        </div>
                        <div :id="'search_end_date_'+index" :class='[dateWorkMode === "YMD" ? "w-100 max-w-140px mb-10px" : "w-100 max-w-120px mb-10px"]'>
                            <md-datepicker :work-mode="dateWorkMode" :attr-name="'search_end_date_' + index" :ref="'search_end_date_' + index" :value="dateWorkMode === 'YMD' ? dateValueTo : dateValue"/>
                        </div>
                    </div>
                </div>
                <!--                    <div v-if="displayDate" class="col-12 max-w-30px mb-10px">-->
                <!--                        <div class="d-flex h-100 align-items-end">-->
                <!--                            <label class="">～</label>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div v-if="displayDate" class="col-12 max-w-140px mb-10px">-->
                <!--                        <div :id="'search_end_date_'+index" class="d-flex h-100 align-items-end">-->
                <!--                            <div class="">-->
                <!--                                <template>-->
                <!--                                    <md-datepicker :work-mode="dateWorkMode" :attr-name="'search_end_date' + index" :ref="'search_end_date' + index" :value="dateValue"/>-->
                <!--                                </template>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--表示項目設定-->
                <div v-if="displayItem" class="col-12 max-w-110px mb-10px">
                    <label class="mb-0">表示項目設定</label>
                    <input type="text" :id="'search_display_item_'+index" class="form-control text-right" value="0個選択" readonly>
                </div>
                <div v-if="displayItem" class="col-12 max-w-110px mb-10px">
                    <div class="d-flex h-100 align-items-end justify-content-center">
                        <button :id="'btn-modal-display-item_'+index" type="button" class="btn btn-sm old-btn center-icon-btn m-0">
                            <span class="w-100">表示項目設定</span>
                        </button>
                    </div>
                </div>
                <!--種別-->
                <div v-if="displayMode" class="col-12 sm-max-w-300px mb-10px">
                    <label :for="'search_mode_select_'+index" class="mb-0">種別</label>
                    <div class="">
                        <select :id="'search_mode_select_'+index" class="custom-mdb-select md-form m-0" :name="'search_mode_select_'+index">
                            <!--                        <option value="" disabled selected>未選択</option>-->
                            <option v-for="mode in modes" :key="mode.id" :value="mode.id" :selected="activeModes.indexOf(mode.id) >= 0">{{mode.name}}</option>
                        </select>
                    </div>
                </div>
                <!--検索ボタン-->
                <div v-if="!displayOptionUpsideDown" class="col-12 max-w-110px mb-10px">
                    <div class="d-flex h-100 align-items-end justify-content-center">
                        <button :id="'btn-search_'+index" type="button" class="btn btn-sm old-btn center-icon-btn m-0">
                            <img class="icon-btn-15" alt="選択表示" src="/images/common/do-search.svg">
                            <span class="w-100">選択表示</span>
                        </button>
                    </div>
                </div>
                <!--                </div>-->
                <!--            </div>-->
            </div>
            <div v-if="displayOptionUpsideDown" class="row mt-10px">
                <div class="d-flex flex-wrap align-items-end" style="flex: 1 1 auto;">
                    <!-- 所属部署 -->
                    <div v-if="displayDepartment" class="col-12 sm-max-w-200px mb-20px">
                        <label :for="'search_department_id_'+index" class="mb-0" style="font-size:0.8rem;">所属部署</label>
                        <div :id="'search_department_id_'+index" class="">
                            <custom-tree-select
                                :items=departments
                                ref="searchDepartmentId"
                                :input-name="'search_department_id_' + index"
                                :value=activeDepartments
                                :multiple=multipleDepartment
                                :open-all="true"
                                selection-type="independent"
                                selection-mode="all"
                                :select-all="false"
                                :input-default-string="inputDefaultString"
                                @on-selection-change="onSelectionChangeDepartment($event)"
                            />
                        </div>
                    </div>
                    <!-- 役職 -->
                    <div v-if="displayPost" class="col-12 sm-max-w-150px mb-20px">
                        <label :for="'search_post_id_'+index" class="mb-0" style="font-size:0.8rem;">役職</label>
                        <div class="">
                            <select :id="'search_post_id_'+index" class="custom-mdb-select md-form m-0" :name="'search_post_id_' + index" v-on:change.stop="onSelectionChange($event)">
                                <option value="">未選択</option>
                                <option v-for="post in posts" :key="post.id" :value=post.id :selected="activePosts.indexOf(post.id) >= 0">{{post.name}}</option>
                            </select>
                        </div>
                    </div>
                    <!-- 雇用体系 -->
                    <div v-if="displayEmployment" class="col-12 sm-max-w-150px mb-20px">
                        <label :for="'search_employment_id_'+index" class="mb-0" style="font-size:0.8rem;">雇用体系</label>
                        <div class="">
                            <select :id="'search_employment_id_'+index" class="custom-mdb-select md-form m-0" :name="'search_employment_id_' + index" v-on:change.stop="onSelectionChange($event)">
                                <option value="">未選択</option>
                                <option v-for="employment in employments" :key="employment.id" :value=employment.id :selected="activeEmployments.indexOf(employment.id) >= 0">{{employment.name}}</option>
                            </select>
                        </div>
                    </div>
                    <!-- 社員 -->
                    <div v-if="displayUser" class="col-12 sm-max-w-250px mb-20px">
                        <label :for="'search_user_id_'+index" class="mb-0" style="font-size:0.8rem;">社員</label>
                        <div class="">
                            <select :id="'search_user_id_'+index" class="custom-mdb-select md-form m-0" :name="'search_user_id_' + index" v-on:change.stop="onSelectionChange($event)" multiple>
                                <option value="" disabled selected>未選択</option>
                                <option v-for="user in users" :key="user.id" :value=user.id :selected="activeUsers.indexOf(user.id) >= 0">{{user.identification_code}} : {{user.name}}</option>
                            </select>
                        </div>
                    </div>
                    <!-- チェックボックス(オプション) -->
                    <div v-if="displayOptionCheckBox" class="col-12 sm-max-w-250px mb-20px">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" :id="'search_option_check_'+index" :name="'search_option_check_' + index" v-model="optionCheckBoxState">
                            <label class="form-check-label ml-0" :for="'search_option_check_'+index">{{ optionCheckBoxString }}</label>
                        </div>
                    </div>
                    <!--検索ボタン-->
                    <div v-if="displayOptionUpsideDown" class="col-12 max-w-110px mb-20px">
                        <div class="d-flex h-100 align-items-end justify-content-center">
                            <button :id="'btn-search_'+index" type="button" class="btn btn-sm old-btn center-icon-btn m-0">
                                <img class="icon-btn-15" alt="選択表示" src="/images/common/do-search.svg">
                                <span class="w-100">選択表示</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="displayOptionSearchCheckBox" class="col-12 sm-max-w-300px" style="">
            <!-- 検索条件チェックボックス1(オプション) -->
            <div v-if="displayOptionSearchCheckBox1" class="row">
                <div class="col-12 sm-max-w-250px mb-0">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" :id="'search_option_search_check1_'+index" :name="'search_option_search_check1_'+index" v-model="optionSearchCheckBoxState1">
                        <label class="form-check-label ml-0" :for="'search_option_search_check1_'+index">{{ optionSearchCheckBoxString1 }}</label>
                    </div>
                </div>
            </div>
            <!-- 検索条件チェックボックス2(オプション) -->
            <div v-if="displayOptionSearchCheckBox2" class="row">
                <div class="col-12 sm-max-w-250px mb-0">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" :id="'search_option_search_check2_'+index" :name="'search_option_search_check2_'+index" v-model="optionSearchCheckBoxState2">
                        <label class="form-check-label ml-0" :for="'search_option_search_check2_'+index">{{ optionSearchCheckBoxString2 }}</label>
                    </div>
                </div>
            </div>
            <!-- 検索条件チェックボックス3(オプション) -->
            <div v-if="displayOptionSearchCheckBox3" class="row">
                <div class="col-12 sm-max-w-250px mb-0">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" :id="'search_option_search_check3_'+index" :name="'search_option_search_check3_'+index" v-model="optionSearchCheckBoxState3">
                        <label class="form-check-label ml-0" :for="'search_option_search_check3_'+index">{{ optionSearchCheckBoxString3 }}</label>
                    </div>
                </div>
            </div>
            <!-- 検索条件チェックボックス4(オプション) -->
            <div v-if="displayOptionSearchCheckBox4" class="row">
                <div class="col-12 sm-max-w-250px mb-0">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" :id="'search_option_search_check4_'+index" :name="'search_option_search_check4_'+index" v-model="optionSearchCheckBoxState4">
                        <label class="form-check-label ml-0" :for="'search_option_search_check4_'+index">{{ optionSearchCheckBoxString4 }}</label>
                    </div>
                </div>
            </div>
            <!-- 検索条件チェックボックス5(オプション) -->
            <div v-if="displayOptionSearchCheckBox5" class="row">
                <div class="col-12 sm-max-w-250px mb-0">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" :id="'search_option_search_check5_'+index" :name="'search_option_search_check5_'+index" v-model="optionSearchCheckBoxState5">
                        <label class="form-check-label ml-0" :for="'search_option_search_check5_'+index">{{ optionSearchCheckBoxString5 }}</label>
                    </div>
                </div>
            </div>
            <div class="row mb-20px"></div>
        </div>
    </div>
</template>

<script>
import treeSelect from '../CustomVueMaterial/custom/CustomTreeSelect/CustomTreeSelect.vue';
import mdDatepicker from '../CustomVueMaterial/components/MdDatepicker/MdDatepicker.vue';

export default  {
    name: "searchForm",
    props:{
        data: {
            type: [Object, String],
            default: () => ({
                departments: [],
                posts: [],
                employments: [],
                users: [],
                modes: []
            })
        },
        active: {
            type: [Object, String],
            default: () => ({
                departments: [],
                posts: [],
                employments: [],
                users: [],
                modes: []
            })
        },
        index:{
            type: Number,
            default: 0
        },
        dateWorkMode:{
            type: String,
            default: 'YM'
        },
        dateValue:{
            type: String,
            default: ''
        },
        dateValueTo:{
            type: String,
            default: ''
        },
        displayDepartment: {
            type: Boolean,
            default: false
        },
        displayPost: {
            type: Boolean,
            default: false
        },
        displayEmployment: {
            type: Boolean,
            default: false
        },
        displayUser: {
            type: Boolean,
            default: false
        },
        displayOptionCheckBox: {
            type: Boolean,
            default: false
        },
        displayOptionSearchCheckBox1: {
            type: Boolean,
            default: false
        },
        displayOptionSearchCheckBox2: {
            type: Boolean,
            default: false
        },
        displayOptionSearchCheckBox3: {
            type: Boolean,
            default: false
        },
        displayOptionSearchCheckBox4: {
            type: Boolean,
            default: false
        },
        displayOptionSearchCheckBox5: {
            type: Boolean,
            default: false
        },
        displayDate: {
            type: Boolean,
            default: false
        },
        displayItem: {
            type: Boolean,
            default: false
        },
        displayMode: {
            type: Boolean,
            default: false
        },
        displayOptionUpsideDown: {
            type: Boolean,
            default: false
        },
        inputDefaultString: {
            type: String,
            default: '全社'
        },
        multipleDepartment: {
            type: Boolean,
            default: false
        },
        optionCheckBoxString: {
            type: String,
            default: ''
        },
        optionSearchCheckBoxString1: {
            type: String,
            default: ''
        },
        optionSearchCheckBoxString2: {
            type: String,
            default: ''
        },
        optionSearchCheckBoxString3: {
            type: String,
            default: ''
        },
        optionSearchCheckBoxString4: {
            type: String,
            default: ''
        },
        optionSearchCheckBoxString5: {
            type: String,
            default: ''
        },
        optionCheckBoxChecked: {
            type: Boolean,
            default: false
        },
        optionSearchCheckBoxChecked1: {
            type: Boolean,
            default: false
        },
        optionSearchCheckBoxChecked2: {
            type: Boolean,
            default: false
        },
        optionSearchCheckBoxChecked3: {
            type: Boolean,
            default: false
        },
        optionSearchCheckBoxChecked4: {
            type: Boolean,
            default: false
        },
        optionSearchCheckBoxChecked5: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            departments: this.data.departments || [],
            posts: this.data.posts || [],
            employments: this.data.employments || [],
            users: this.data.users || [],
            modes: this.data.modes || [],
            activeDepartments: this.active.departments || [],
            activePosts: this.active.posts || [],
            activeEmployments: this.active.employments || [],
            activeUsers: this.active.users || [],
            activeModes: this.active.modes || [],
            optionCheckBoxState: this.optionCheckBoxChecked || false,
            optionSearchCheckBoxState1: this.optionSearchCheckBoxChecked1 || false,
            optionSearchCheckBoxState2: this.optionSearchCheckBoxChecked2 || false,
            optionSearchCheckBoxState3: this.optionSearchCheckBoxChecked3 || false,
            optionSearchCheckBoxState4: this.optionSearchCheckBoxChecked4 || false,
            optionSearchCheckBoxState5: this.optionSearchCheckBoxChecked5 || false,
            displayOptionSearchCheckBox: this.displayOptionSearchCheckBox1 || this.displayOptionSearchCheckBox2 || this.displayOptionSearchCheckBox3 || this.displayOptionSearchCheckBox4 || this.displayOptionSearchCheckBox5,
        }
    },
    components: {
        treeSelect,
        mdDatepicker
    },
    computed: {
    },
    methods: {
        onSelectionChangeDepartment(value){
            const target = $(this.$el);
            const data_v = {};
            if (!this.displayUser){
                return;
            }
            if (this.multipleDepartment == true){
                data_v['search_department_id_' + this.index] = value;
            } else {
                data_v['search_department_id_' + this.index] = value[0];
            }
            this.getFieldContents(target, "search_department_id_" + this.index, data_v ,this.index)
                .then((data, status, xhr) => {
                    this.setComponent(data,this.index);
                })
                .catch((xhr, status, error) => {
                    console.log('error')
                });
        },
        onSelectionChange(e){
            const target = $(e.currentTarget);

            this.getFieldContents(target, target.attr('id'), null, this.index)
                .then((data, status, xhr) => {
                    this.setComponent(data,this.index);
                })
                .catch((xhr, status, error) => {
                    console.log('error')
                });
        },
        getFieldContents: (targetElem, key, values= {}, index) =>{

            const sendData = targetElem.closest('form').serializeObject();

            if (key) {
                sendData.key = key;
            }

            sendData.mode = $('select[name="search_user_id_' + index + '"]').attr('multiple');

            for (let key in values) {
                sendData[key] = values[key];
            }

            const page = targetElem.closest('form').attr('id').split('-')[0];
            if(page){
                sendData.page = page;
            }else{
                sendData.page = 'other'
            }

            const fiscalYear = $('input[name="budget_year"]').val();

            if(fiscalYear){
                sendData.fiscal_year = fiscalYear;
            }

            sendData.index = index;

            return $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                type: "POST",
                url: "/app/common/search-form/build",
                data: sendData,
            });
        },
        setComponent:(data,index) => {
            const posts = JSON.parse(data.posts);
            if (posts) {
                let target = $('select[name="search_post_id_' + index + '"]');
                target.empty();
                let option = new Option('未選択', '', false, false);
                target.append(option);
                posts.forEach((post) => {
                    if (post.id === data.active_post) {
                        option = new Option(post.name, post.id, false, true);
                    } else {
                        option = new Option(post.name, post.id, false, false);
                    }
                    target.append(option);
                });
                target.customMaterialSelect();
            }

            const employments = JSON.parse(data.employments);
            if (employments) {
                let target = $('select[name="search_employment_id_' + index + '"]');
                target.empty();
                let option = new Option('未選択', '', false, false);
                target.append(option);
                employments.forEach((employment) => {
                    if (employment.id === data.active_employment) {
                        option = new Option(employment.name, employment.id, false, true);
                    } else {
                        option = new Option(employment.name, employment.id, false, false);
                    }
                    target.append(option);
                });
                target.customMaterialSelect();
            }

            const users = JSON.parse(data.users);
            if (users) {
                let target = $('select[name="search_user_id_' + index + '"]');
                target.empty();
                let option = null;
                if(target.attr('multiple')){
                    option = new Option('未選択', '', false, false);
                    option.disabled = true;
                    target.append(option);
                }else{
                    option = new Option('未選択', '', false, false);
                    target.append(option);
                }
                users.forEach((user) => {
                    if (user.id === data.active_user) {
                        option = new Option((user.identification_code ? user.identification_code : '') + ' : ' + user.name, user.id, false, true);
                    } else {
                        option = new Option((user.identification_code ? user.identification_code : '') + ' : ' + user.name, user.id, false, false);
                    }
                    target.append(option);
                });
                target.customMaterialSelect();
            }

            if(data.active_department){
                // searchDepartmentTreeSelect.$refs.searchDepartmentId.CustomTreeSelect.value=[Number(data.active_department)];
                treeSelect.$refs.searchDepartmentId.CustomTreeSelect.value=[Number(data.active_department)];
            }

            if(data.active_post){
                let select = $('select[name="search_post_id_' + index + '"]');
                select.val(data.active_post);
            }

            if(data.active_employment){
                let select = $('select[name="search_employment_id_' + index + '"]');
                select.val(data.active_employment);
            }

            if(data.active_user){
                let select = $('select[name="search_user_id_' + index + '"]');
                select.val(data.active_user);
            }
        },
        getSearchDepartmentTreeSelect: ()=>{
            // return searchDepartmentTreeSelect;
            return treeSelect;
        },
    },
}
</script>

<style scoped>

</style>
